(function () {
  'use strict';

  var DISCOUNT_CODE = 'WELKOM15';
  var STORAGE_KEY = 'dhs_welcome_discount';
  var CHECKOUT_KEY = 'dhs_welcome_checkout_visited';
  var REJECTED_KEY = 'dhs_welcome_discount_rejected';
  var MANUAL_REMOVAL_KEY = 'dhs_welcome_discount_manually_removed';
  var ACTIVE_CLASS = 'welcome-discount-active';
  var LIFETIME_DAYS = 30;
  var stateRevision = 0;
  var activatingWelcomeCode = false;
  var activationPromise = null;
  var cartReadPromise = null;
  var cartSyncPromise = null;
  var lastCartEmpty = null;
  var removingWelcomeCode = false;
  var restoringWelcomeCode = false;
  var checkoutIntent = false;
  var cleanupPromise = null;
  var syncTimer = null;
  var rejection = null;
  var noticeTimer = null;
  var noticeCloseTimer = null;
  var noticeHideTimer = null;


  // Restore an explicitly selected offer across Shopify's sign-in redirect.
  var RETURN_SELECTION_KEY = 'dhs_welcome_checkout_selection_v2';
  var loginRecovery = null;
  var loginReturnProtected = false;
  function rememberCheckoutSelection() {
    var selected = getSavedDiscount();
    if (!selected || wasManuallyRemoved()) return;
    try { sessionStorage.setItem(RETURN_SELECTION_KEY, JSON.stringify({
      code: DISCOUNT_CODE, expiresAt: Math.min(selected.expiresAt, Date.now() + 3600000)
    })); } catch (error) {}
  }
  function clearCheckoutSelection() {
    try { sessionStorage.removeItem(RETURN_SELECTION_KEY); } catch (error) {}
  }
  function recoverAfterLogin() {
    if (!window.DHSWelcomeCustomer || isReturningCustomer() ||
        new URLSearchParams(window.location.search).get('logged_in') !== 'true' ||
        wasManuallyRemoved()) return null;
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(RETURN_SELECTION_KEY) || 'null'); } catch (error) {}
    if (!getSavedDiscount() && !(pending && pending.code === DISCOUNT_CODE && pending.expiresAt > Date.now())) return null;
    if (!getSavedDiscount()) saveDiscount();
    setActive();
    return applyDiscountToShopify().catch(function() {
      // A network failure does not invalidate a first-order offer.
    }).then(function() {
      clearCheckoutSelection();
      loginRecovery = null;
      refreshCartDrawer();
    });
  }

  var checkoutPreparing = null;
  var checkoutReadyUntil = 0;
  var checkoutReadyForm = null;
  var restoreAttempted = false;
  function isReturningCustomer() {
    return Boolean(window.DHSWelcomeCustomer && window.DHSWelcomeCustomer.ordersCount > 0);
  }
  function chosenWelcomeDiscount() {
    return !wasManuallyRemoved() && !isReturningCustomer() && Boolean(getSavedDiscount());
  }
  function carryWelcomeCodeToCheckout(checkedCart) {
    if (checkoutPreparing) return checkoutPreparing;
    var pendingActivation = activationPromise || loginRecovery;
    checkoutPreparing = Promise.resolve(pendingActivation).then(function () {
      if (!chosenWelcomeDiscount()) return false;
      return checkedCart && !pendingActivation ? checkedCart : readCart();
    }).then(function (cart) {
      if (!cart || !chosenWelcomeDiscount()) return false;
      if (cartContainsWelcomeCode(cart) === true) return cart;
      return applyDiscountToShopify(true, cart);
    }).then(function (result) {
      if (result === false && chosenWelcomeDiscount()) throw new Error('Kortingscode opnieuw controleren.');
      return result;
    }).finally(function () { checkoutPreparing = null; });
    return checkoutPreparing;
  }

  function wasManuallyRemoved() {
    if (removingWelcomeCode) return true;
    var removedAt = 0;
    try { removedAt = Number(localStorage.getItem(MANUAL_REMOVAL_KEY)); } catch (error) {}
    if (!removedAt) {
      try { removedAt = Number(sessionStorage.getItem(MANUAL_REMOVAL_KEY)); } catch (error) {}
    }
    return removedAt > Date.now() - LIFETIME_DAYS * 86400000;
  }

  function rememberManualRemoval() {
    removingWelcomeCode = true;
    clearCheckoutSelection();
    try { localStorage.setItem(MANUAL_REMOVAL_KEY, String(Date.now())); } catch (error) {}
    try { sessionStorage.setItem(MANUAL_REMOVAL_KEY, String(Date.now())); } catch (error) {}
    clearCheckoutHistory();
  }

  function clearManualRemoval() {
    removingWelcomeCode = false;
    try { localStorage.removeItem(MANUAL_REMOVAL_KEY); } catch (error) {}
    try { sessionStorage.removeItem(MANUAL_REMOVAL_KEY); } catch (error) {}
  }

  function getRejection() {
    // Older versions stored cart applicability as a customer rejection.
    // Only Shopify's authenticated order history may disqualify a customer.
    clearRejection();
    return null;
  }

  function clearRejection() {
    rejection = null;
    try { localStorage.removeItem(REJECTED_KEY); } catch (error) {}
    try { sessionStorage.removeItem(REJECTED_KEY); } catch (error) {}
  }

  function rememberRejection(notify) {
    var existing = getRejection();
    rejection = existing || { code: DISCOUNT_CODE, source: 'checkout', expiresAt: Date.now() + LIFETIME_DAYS * 86400000 };
    try { localStorage.setItem(REJECTED_KEY, JSON.stringify(rejection)); } catch (error) {}
    try { sessionStorage.setItem(REJECTED_KEY, JSON.stringify(rejection)); } catch (error) {}
    /* Een afwijzing mag de oorspronkelijke aanbieding niet opnieuw openen. */
    try { localStorage.setItem('dhs_welcome_popup_discount_selected', String(Date.now())); } catch (error) {}
    document.dispatchEvent(new CustomEvent('welcome-discount:rejected', { detail: { code: DISCOUNT_CODE } }));
    /* Deze status verplicht een nieuwe controle, maar blokkeert geen klant.
       Alleen een bewuste activatie met actuele afwijzing toont de melding. */
    if (notify) showUnavailableNotice();
  }

  function showUnavailableNotice() {
    var notice = document.querySelector('[data-welcome-discount-unavailable]');
    if (!notice || (window.Shopify && window.Shopify.designMode)) return;
    window.clearTimeout(noticeTimer);
    var popup = document.querySelector('dhs-welcome-popup');
    var cookiePrompt = popup && typeof popup.cookieBannerVisible === 'function' && popup.cookieBannerVisible();
    if (cookiePrompt) {
      noticeTimer = window.setTimeout(showUnavailableNotice, 300);
      return;
    }
    window.clearTimeout(noticeCloseTimer);
    window.clearTimeout(noticeHideTimer);
    notice.hidden = false;
    /* Een handmatige popover blijft ook boven een quick-viewdialoog zichtbaar
       zonder focus te verplaatsen of het winkelen te onderbreken. */
    if (typeof notice.showPopover === 'function' && !notice.matches(':popover-open')) notice.showPopover();
    var message = notice.querySelector('[data-welcome-discount-unavailable-message]');
    /* Herhaal de aankondiging voor schermlezers ook bij een volgende klik. */
    if (message) {
      var text = message.dataset.message;
      message.textContent = '';
      window.requestAnimationFrame(function () { message.textContent = text; });
    }
    window.requestAnimationFrame(function () {
      if (!notice.hidden) notice.classList.add('is-visible');
    });
    noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000);
  }

  function closeUnavailableNotice() {
    window.clearTimeout(noticeTimer);
    window.clearTimeout(noticeHideTimer);
    var notice = document.querySelector('[data-welcome-discount-unavailable]');
    if (!notice || notice.hidden) return;
    notice.classList.remove('is-visible');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.clearTimeout(noticeCloseTimer);
    noticeCloseTimer = window.setTimeout(function () {
      if (typeof notice.hidePopover === 'function') notice.hidePopover();
      notice.hidden = true;
    }, reducedMotion ? 0 : 240);
  }

  function hasVisitedCheckout() {
    try { if (sessionStorage.getItem(CHECKOUT_KEY) === 'true') return true; } catch (error) {}
    var saved = getSavedDiscount();
    return Boolean(saved && saved.checkoutVisited);
  }

  function rememberCheckoutVisit() {
    rememberCheckoutSelection();
    try { sessionStorage.setItem(CHECKOUT_KEY, 'true'); } catch (error) {}
    var saved = getSavedDiscount();
    if (saved) {
      saved.checkoutVisited = true;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(saved)); } catch (error) {}
    }
  }

  function clearCheckoutHistory() {
    checkoutIntent = false;
    try { sessionStorage.removeItem(CHECKOUT_KEY); } catch (error) {}
  }

  function getSavedDiscount() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || saved.code !== DISCOUNT_CODE || saved.expiresAt <= Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return saved;
    } catch (error) {
      return null;
    }
  }

  function saveDiscount() {
    var expiresAt = Date.now() + LIFETIME_DAYS * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        active: true,
        code: DISCOUNT_CODE,
        expiresAt: expiresAt
      }));
    } catch (error) {
      /* De winkelwagen blijft de bron van waarheid als opslag geblokkeerd is. */
    }
  }

  function discountUrl() {
    var redirectPath = window.location.pathname + window.location.search;
    return '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=' + encodeURIComponent(redirectPath);
  }

  function establishDiscountSession(cart, revision) {
    return fetch(discountUrl(), {
      method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store',
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    }).then(function(response) {
      if (!response.ok) throw new Error('Kortingscode kon niet worden doorgegeven.');
      if (wasManuallyRemoved() || isReturningCustomer()) {
        removeRejectedWelcomeCode(cart);
        return false;
      }
      return revision === stateRevision ? cart : false;
    });
  }

  function applyDiscountToShopify(forCheckout, knownCart) {
    if (cleanupPromise) return cleanupPromise.then(function () { return applyDiscountToShopify(forCheckout, knownCart); });
    if (isReturningCustomer() || wasManuallyRemoved()) return Promise.resolve(false);
    var applyRevision = stateRevision;
    return (knownCart ? Promise.resolve(knownCart) : readCart()).then(function(cart) {
      if (applyRevision !== stateRevision || wasManuallyRemoved() || isReturningCustomer()) return false;
      var codes = [];
      function keep(code) {
        if (code && !isWelcomeCode(code) && codes.indexOf(code) === -1) codes.push(code);
      }
      if (Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(function(discount) { keep(typeof discount === 'string' ? discount : discount && discount.code); });
      } else {
        function keepApplication(application) {
          if (application && (application.type === 'discount_code' || application.type === 'code')) keep(application.code || application.title);
        }
        (cart.cart_level_discount_applications || []).forEach(keepApplication);
        (cart.items || []).forEach(function(item) {
          (item.line_level_discount_allocations || item.discount_allocations || []).forEach(function(allocation) {
            keepApplication(allocation.discount_application || allocation.application);
          });
        });
      }
      codes.push(DISCOUNT_CODE);
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true, detail: { sections: sections }
      }));
      var update = { discount: codes.join(',') };
      if (sections.length) {
        update.sections = sections.slice(0, 5);
        update.sections_url = window.location.pathname;
      }
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(update)
      }).then(function(response) {
        if (!response.ok) throw new Error('Kortingscode kon niet worden doorgegeven.');
        return response.json();
      }).then(function(updated) {
        if (wasManuallyRemoved() || isReturningCustomer()) {
          removeRejectedWelcomeCode(updated);
          return false;
        }
        if (applyRevision !== stateRevision) return false;
        // The cart update is sufficient for activation; establish the session at checkout.
        if (!forCheckout) return updated;
        // Establish Shopify's discount session as well as the cart code.
        return updated;
      });
    });
  }

  function setActive() {
    if (wasManuallyRemoved() || isReturningCustomer()) return;
    if (document.documentElement.classList.contains(ACTIVE_CLASS)) return;
    document.documentElement.classList.add(ACTIVE_CLASS);
    document.dispatchEvent(new CustomEvent('welcome-discount:activated', {
      detail: { code: DISCOUNT_CODE, percentage: 15 }
    }));
  }

  function refreshCartDrawer(cart) {
    var theme = window.FoxTheme;
    if (cart && Array.isArray(cart.items) && cart.sections &&
        Object.keys(cart.sections).length &&
        Object.keys(cart.sections).every(function (key) { return typeof cart.sections[key] === 'string'; }) &&
        theme && theme.pubsub && theme.PUB_SUB_EVENTS) {
      theme.pubsub.publish(theme.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: false }
    }));
  }

  function resetActive() {
    var wasActive = document.documentElement.classList.contains(ACTIVE_CLASS);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}

    document.documentElement.classList.remove(ACTIVE_CLASS);
    document.querySelectorAll('[data-welcome-discount-activate]').forEach(function (button) {
      var label = button.querySelector('[data-welcome-discount-button-text]');
      if (label) label.textContent = button.getAttribute('data-welcome-discount-original-text') || label.textContent || '15% korting op je eerste bestelling';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    if (!wasActive) return;
    document.dispatchEvent(new CustomEvent('welcome-discount:deactivated', {
      detail: { code: DISCOUNT_CODE }
    }));
  }

  function isWelcomeCode(code) {
    return String(code || '').trim().toUpperCase() === DISCOUNT_CODE;
  }

  function cartContainsWelcomeCode(cart) {
    if (!cart) return null;

    /* De ingevoerde codes zijn leidend, ook wanneer er geen productkorting is. */
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(function (discount) {
        return typeof discount === 'string'
          ? isWelcomeCode(discount)
          : discount && isWelcomeCode(discount.code);
      });
    }

    if (Array.isArray(cart.cart_level_discount_applications)) {
      if (cart.cart_level_discount_applications.some(function (application) {
        return isWelcomeCode(application && (application.title || application.code));
      })) return true;
    }

    if (Array.isArray(cart.items)) {
      var welcomeAllocationFound = cart.items.some(function (item) {
        var allocations = item.discount_allocations || item.line_level_discount_allocations || [];
        return allocations.some(function (allocation) {
          var application = allocation.discount_application || allocation.application || {};
          return isWelcomeCode(application.title || application.code);
        });
      });
      if (welcomeAllocationFound) return true;
    }

    return Array.isArray(cart.items) || Array.isArray(cart.cart_level_discount_applications) ? false : null;
  }

  function cartHasOtherWinningProductCode(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      var allocations = item.discount_allocations || item.line_level_discount_allocations || [];
      return allocations.some(function (allocation) {
        var application = allocation.discount_application || allocation.application || {};
        var code = application.title || application.code;
        var isDiscountCode = application.type === 'discount_code' || application.type === 'code';
        return isDiscountCode && code && !isWelcomeCode(code);
      });
    });
  }

  function welcomeCodeRejected(cart) {
    return Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (discount) {
      return discount && isWelcomeCode(discount.code) && discount.applicable === false;
    });
  }

  function cartHasAppliedWelcomeDiscount(cart) {
    if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.some(function (application) {
      return application && isWelcomeCode(application.title || application.code) && Number(application.total_allocated_amount) > 0;
    })) return true;
    if (Array.isArray(cart.items)) {
      return cart.items.some(function (item) {
        return (item.line_level_discount_allocations || item.discount_allocations || []).some(function (allocation) {
          var application = allocation.discount_application || allocation.application || {};
          return isWelcomeCode(application.title || application.code) && Number(allocation.amount) > 0;
        });
      });
    }
    return Array.isArray(cart.cart_level_discount_applications) ? false : null;
  }

  function removeRejectedWelcomeCode(cart) {
    if (cleanupPromise) return;
    var codes = [];
    function keepCode(code) {
      if (code && !isWelcomeCode(code) && codes.indexOf(code) === -1) codes.push(code);
    }
    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        keepCode(typeof discount === 'string' ? discount : discount && discount.code);
      });
    } else {
      function keepApplication(application) {
        if (application && (application.type === 'discount_code' || application.type === 'code')) {
          keepCode(application.code || application.title);
        }
      }
      (cart.cart_level_discount_applications || []).forEach(keepApplication);
      (cart.items || []).forEach(function (item) {
        (item.discount_allocations || item.line_level_discount_allocations || []).forEach(function (allocation) {
          keepApplication(allocation.discount_application || allocation.application);
        });
      });
    }
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    cleanupPromise = fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('Kortingscode kon niet worden verwijderd.');
      refreshCartDrawer();
    }).catch(function () {
      /* De website blijft gedeactiveerd; een volgende controle probeert opnieuw. */
    }).then(function () { cleanupPromise = null; });
  }

  function syncDiscountFromCart(cart) {
    if (!cart || loginRecovery || checkoutPreparing || checkoutIntent || activatingWelcomeCode) return;
    if (wasManuallyRemoved()) { resetActive(); return; }
    if (isReturningCustomer()) {
      var hadCode = cartContainsWelcomeCode(cart);
      clearCheckoutSelection();
      resetActive();
      if (hadCode === true) removeRejectedWelcomeCode(cart);
      return;
    }
    var saved = getSavedDiscount();
    var contains = cartContainsWelcomeCode(cart);
    if (saved || contains === true) {
      if (!saved) saveDiscount();
      setActive();
      // An absent or temporarily inapplicable code does not revoke eligibility.
      // Restore once per page; checkout performs a fresh handoff as well.
      if (saved && contains === false && cart.items && cart.items.length &&
          !restoreAttempted && !restoringWelcomeCode) {
        restoreAttempted = true;
        restoringWelcomeCode = true;
        applyDiscountToShopify().then(function(response) {
          if (response !== false && chosenWelcomeDiscount()) refreshCartDrawer(response);
        }).catch(function() {
          // Retain the selection on a network error; checkout can retry.
        }).finally(function() { restoringWelcomeCode = false; });
      }
    }
  }

  function blockIneligibleActivation() {
    if (!isReturningCustomer()) return false;
    resetActive();
    showUnavailableNotice();
    return true;
  }

  function activate(button) {
    if (!button || button.getAttribute('aria-busy') === 'true' || activatingWelcomeCode) return;
    if (blockIneligibleActivation()) return;
    clearManualRemoval();
    stateRevision += 1;
    var revision = stateRevision;

    var text = button.querySelector('[data-welcome-discount-button-text]');
    var originalText = text ? text.textContent : '';
    button.setAttribute('data-welcome-discount-original-text', originalText);
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (text) text.textContent = 'Korting activeren…';

    activatingWelcomeCode = true;
    activationPromise = applyDiscountToShopify()
      .then(function (response) {
        if (text) text.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (revision !== stateRevision || response === false || getRejection()) return;
        clearCheckoutHistory();
        saveDiscount();
        setActive();
        refreshCartDrawer(response);
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (text) text.textContent = 'Probeer opnieuw';
        window.setTimeout(function () {
          if (text) text.textContent = originalText;
        }, 2500);
      }).finally(function () { activatingWelcomeCode = false; activationPromise = null; });
  }

  function readCart() {
    if (cartReadPromise) return cartReadPromise;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    cartReadPromise = fetch(root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Winkelwagen kon niet worden gelezen.');
        return response.json();
      }).finally(function () { cartReadPromise = null; });
    return cartReadPromise;
  }

  function syncSavedDiscount() {
    if (loginRecovery || checkoutPreparing || checkoutIntent || activatingWelcomeCode) return;
    if (cartSyncPromise) return cartSyncPromise;
    var revision = stateRevision;
    cartSyncPromise = readCart().then(function (cart) {
        if (revision === stateRevision) syncDiscountFromCart(cart);
      })
      .catch(function () {
        /* Een netwerkfout verandert de gekozen korting niet. */
        // Keep the explicit choice if the cart request fails.
        if (revision === stateRevision && chosenWelcomeDiscount()) setActive();
      }).finally(function () { cartSyncPromise = null; });
    return cartSyncPromise;
  }

  function scheduleCartSync() {
    if (!getSavedDiscount() && !hasVisitedCheckout() && !document.documentElement.classList.contains(ACTIVE_CLASS)) return;
    window.clearTimeout(syncTimer);
    var revision = stateRevision;
    syncTimer = window.setTimeout(function () {
      if (revision === stateRevision) syncSavedDiscount();
    }, 80);
  }

  document.addEventListener('click', function (event) {
    /* Hyper vervangt de drawer-header na cart:refresh zonder de sluitknop opnieuw te koppelen. */
    var drawerCloseButton = event.target.closest('cart-drawer .drawer__header button.drawer__close-btn[aria-controls]');
    if (drawerCloseButton) {
      var drawer = drawerCloseButton.closest('cart-drawer');
      /* De bestaande Hyper-handler heeft voorrang; herstel alleen een losgeraakte knop. */
      if (drawer && drawer.open) drawer.hide();
    }

    var removeButton = event.target.closest('button[is="cart-discount-remove"]');
    if (removeButton) {
      var discountItem = removeButton.closest('[data-discount-code]');
      if (discountItem && isWelcomeCode(discountItem.getAttribute('data-discount-code'))) {
        stateRevision += 1;
        rememberManualRemoval();
        resetActive();
        closeUnavailableNotice();
      }
    }

    var button = event.target.closest('[data-welcome-discount-activate]');
    if (!button) return;
    event.preventDefault();
    activate(button);
  });

  /*
   * Hyper verstuurt dit event na toevoegen/verwijderen van een kortingscode.
   * Daardoor verdwijnt de visuele 15%-prijs direct wanneer WELKOM15 uit de
   * winkelmand wordt verwijderd. Andere kortingscodes hebben geen invloed.
   */
  document.addEventListener('cart:updated', function (event) {
    if (loginRecovery || checkoutPreparing || checkoutIntent || activatingWelcomeCode) return;
    stateRevision += 1;
    syncDiscountFromCart(event.detail && event.detail.cart);
  });

  document.addEventListener('submit', function(event) {
    // The minimum-order controller coordinates both checks for these forms.
    if (window.minimumOrderCheckoutListenerAdded && event.target &&
        (event.target.id === 'cart' || event.target.classList.contains('drawer__footer-buttons'))) return;
    if (event.defaultPrevented || !event.submitter || event.submitter.name !== 'checkout' ||
        (!chosenWelcomeDiscount() && !activatingWelcomeCode) ||
        (checkoutReadyForm === event.target && checkoutReadyUntil > Date.now())) return;
    var checked = window.DHSMinimumOrderCart;
    var checkedCart = checked && checked.form === event.target &&
      Date.now() - checked.checkedAt < 30000 ? checked.cart : null;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPreparing) return;
    var form = event.target, submitter = event.submitter;
    var drawer = form.closest('cart-drawer');
    var cartPage = form.id === 'cart';
    carryWelcomeCodeToCheckout(checkedCart).then(function(cart) {
      if (!chosenWelcomeDiscount() || !cart) return;
      var nextForm = form.isConnected ? form : (drawer && drawer.isConnected ? drawer.querySelector('form.drawer__footer-buttons') : (cartPage ? document.getElementById('cart') : null));
      var nextSubmitter = nextForm === form && submitter.isConnected ? submitter : nextForm && nextForm.querySelector('[name="checkout"]');
      if (!nextForm || !nextForm.isConnected || !nextSubmitter || !nextSubmitter.isConnected) throw new Error('Winkelwagen opnieuw openen.');
      window.DHSWelcomeCheckoutCart = { form: nextForm, cart: cart, checkedAt: Date.now() };
      checkoutReadyForm = nextForm;
      checkoutReadyUntil = Date.now() + 30000;
      nextForm.requestSubmit(nextSubmitter);
    }).catch(function() {
      // Do not silently navigate without forwarding a selected discount.
      showUnavailableNotice();
    });
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.submitter && event.submitter.name === 'checkout') {
      checkoutIntent = !event.defaultPrevented;
      /* Bewaar dit al bij de toegestane submit, niet pas bij pagehide.
         De minimum-bestelwaardecontrole blokkeert de eerste submit en
         verstuurt daarna opnieuw als afrekenen daadwerkelijk is toegestaan. */
      if (checkoutIntent) { checkoutReadyForm = null; checkoutReadyUntil = 0; rememberCheckoutSelection(); }
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    var url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && /\/(checkouts?)(\/|$)/.test(url.pathname)) {
      if (chosenWelcomeDiscount() || activatingWelcomeCode) {
        event.preventDefault();
        carryWelcomeCodeToCheckout().then(function() {
          if (!chosenWelcomeDiscount()) return;
          checkoutIntent = true;
          rememberCheckoutSelection();
          var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          window.location.assign(root + 'discount/' + encodeURIComponent(DISCOUNT_CODE) +
            '?redirect=' + encodeURIComponent(url.pathname + url.search));
        }).catch(showUnavailableNotice);
        return;
      }
      checkoutIntent = true;
      rememberCheckoutSelection();
    }
  });

  /* Een gewone link terug vanuit checkout kan ook een nieuwe pagina laden. */
  try {
    var referrer = document.referrer && new URL(document.referrer);
    if (referrer && referrer.origin === window.location.origin && /\/(checkouts?)(\/|$)/.test(referrer.pathname)) {
      rememberCheckoutVisit();
      if (isReturningCustomer()) document.documentElement.classList.remove(ACTIVE_CLASS);
    }
  } catch (error) {}

  window.addEventListener('pagehide', function () {
    window.clearTimeout(syncTimer);
    if (!checkoutIntent) return;
    rememberCheckoutVisit();
    /* Checkout openen trekt de gekozen korting niet in. */
  });

  window.addEventListener('pageshow', function (event) {
    removingWelcomeCode = false;
    checkoutIntent = false;
    checkoutReadyForm = null;
    checkoutReadyUntil = 0;
    restoreAttempted = false;
    if (!event.persisted && !hasVisitedCheckout()) return;
    if (wasManuallyRemoved() || isReturningCustomer()) resetActive();
    else if (chosenWelcomeDiscount()) setActive();
    scheduleCartSync();
  });

  window.addEventListener('focus', scheduleCartSync);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleCartSync();
  });
  document.addEventListener('drawer:handleAfterShow', function (event) {
    if (event.target.matches('cart-drawer')) scheduleCartSync();
  });

  var unavailableNotice = document.querySelector('[data-welcome-discount-unavailable]');
  if (unavailableNotice) {
    unavailableNotice.addEventListener('click', function (event) {
      if (event.target.closest('[data-welcome-discount-unavailable-close]')) closeUnavailableNotice();
    });
    unavailableNotice.addEventListener('mouseenter', function () { window.clearTimeout(noticeHideTimer); });
    unavailableNotice.addEventListener('focusin', function () { window.clearTimeout(noticeHideTimer); });
    unavailableNotice.addEventListener('mouseleave', function () { noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000); });
    unavailableNotice.addEventListener('focusout', function () { noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000); });
    unavailableNotice.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeUnavailableNotice(); });
  }
  window.addEventListener('storage', function (event) {
    if (event.key === REJECTED_KEY && getRejection()) {
      stateRevision += 1;
      resetActive();
    }
  });

  window.DHSWelcomeDiscount = {
    prepareCheckout: function (cart) {
      if (!chosenWelcomeDiscount() && !activatingWelcomeCode && !loginRecovery) return Promise.resolve(cart);
      return carryWelcomeCodeToCheckout(cart).then(function (updated) {
        if (!updated) throw new Error('Kortingscode kon niet worden gecontroleerd.');
        return updated;
      });
    },
    activate: function () {
      if (activatingWelcomeCode) return Promise.resolve(false);
      if (blockIneligibleActivation()) return Promise.resolve(false);
      clearManualRemoval();
      stateRevision += 1;
      var revision = stateRevision;
      activatingWelcomeCode = true;
      activationPromise = applyDiscountToShopify().then(function (response) {
        if (revision !== stateRevision || response === false || getRejection()) return;
        clearCheckoutHistory();
        saveDiscount();
        setActive();
        refreshCartDrawer(response);
      }).finally(function () { activatingWelcomeCode = false; activationPromise = null; });
      return activationPromise;
    },
    resetDisplay: function () {
      resetActive();
    }
  };

  loginRecovery = recoverAfterLogin();
  if (!loginRecovery) {
    if (wasManuallyRemoved() || isReturningCustomer()) resetActive();
    syncSavedDiscount();
  }
})();

